import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class EpdkErrorDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, errorMessages: string[]; }) {
  }
}